import { render, staticRenderFns } from "./PageFormModal.vue?vue&type=template&id=161dd2d8&scoped=true"
import script from "./PageFormModal.vue?vue&type=script&lang=js"
export * from "./PageFormModal.vue?vue&type=script&lang=js"
import style0 from "./PageFormModal.vue?vue&type=style&index=0&id=161dd2d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161dd2d8",
  null
  
)

export default component.exports